/** Stable, expand-order-independent testid suffix for a group's sub-rows. */
export function subRowTestId(groupId: string, index: number): string {
  return `sub-${groupId}-${index}`;
}
